import moment from 'moment';
import HelperMixin from '../../../Shared/HelperMixin.vue';
import PaginationHelper from '../../../Shared/PaginationHelper.vue';

export default {
    name: 'Coupons',
    mixins: [HelperMixin],
    components: {
        PaginationHelper
    },

    async created() {
        this.loginDetails = await this.CheckLoginStatus();

        if (this.loginDetails) {
            if (this.loginDetails.userType != 1)
                this.logout();
        } else {
            this.logout();
        }

        this.GetInfo();
    },

    computed: {
        totalPages() {
            return Math.ceil(this.pages / this.pageSize);
        }
    },

    filters: {
        moment: function (date) {
            if (date === null) {
                return "فارغ";
            }
            return moment(date).format('DD/MM/YYYY');
        },
        discountType: function (type) {
            if (type == 1) return 'نسبة مئوية';
            if (type == 2) return 'مبلغ ثابت';
            return 'غير معروف';
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',

            ScreenTitle: ' إدارة الكوبونات ',
            ScreenTitleSingle: ' كوبون ',

            Info: [],
            AddDialog: false,
            SelectedItem: '',

            ruleForm: {
                Id: null,
                Name: '',
                Code: '',
                DiscountType: 1,
                Value: 0,
                ExpiryDate: null,
                UsageLimit: null
            },
            rules: {
                Name: this.$helper.Required(),
                Code: this.$helper.Required(),
            },
        };
    },

    methods: {
        GetInfo(pageNo) {
            this.pageNo = pageNo;
            if (this.pageNo === undefined) {
                this.pageNo = 1;
            }

            if (!this.Search)
                this.$blockUI.Start();
            
            this.$http.GetCoupons(this.pageNo, this.pageSize, this.Search)
                .then(response => {
                    if (!this.Search)
                        this.$blockUI.Stop();

                    this.Info = response.data.info;
                    this.pages = response.data.count;
                })
                .catch(() => {
                    if (!this.Search)
                        this.$blockUI.Stop();
                    this.pages = 0;
                });
        },

        OpenAddDialog() {
            this.SelectedItem = '';
            this.ruleForm = {
                Id: null,
                Name: '',
                Code: this.GenerateCode(),
                DiscountType: 1,
                Value: 0,
                ExpiryDate: null,
                UsageLimit: null
            };
            this.AddDialog = true;
        },

        OpenEditDialog(item) {
            this.SelectedItem = item;
            this.ruleForm = {
                Id: item.id,
                Name: item.name,
                Code: item.code,
                DiscountType: item.discountType,
                Value: item.value,
                ExpiryDate: item.expiryDate,
                UsageLimit: item.usageLimit
            };
            this.AddDialog = true;
        },

        SubmitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$blockUI.Start();
                    let action = this.ruleForm.Id ? this.$http.EditCoupons(this.ruleForm) : this.$http.AddCoupons(this.ruleForm);
                    
                    action.then(response => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage(response.data);
                        this.AddDialog = false;
                        this.GetInfo(this.pageNo);
                    }).catch(error => {
                        this.$blockUI.Stop();
                        this.$helper.ShowMessage(error.response.data, 'error');
                    });
                }
            });
        },

        Delete(id) {
            this.$confirm('هل أنت متأكد من حذف هذا الكوبون؟', 'تنبيه', {
                confirmButtonText: 'نعم',
                cancelButtonText: 'لا',
                type: 'warning'
            }).then(() => {
                this.$blockUI.Start();
                this.$http.DeleteCoupons(id).then(response => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage(response.data);
                    this.GetInfo(this.pageNo);
                }).catch(error => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage(error.response.data, 'error');
                });
            });
        },

        ChangeStatus(id) {
            this.$blockUI.Start();
            this.$http.ChangeStatusCoupons(id).then(response => {
                this.$blockUI.Stop();
                this.$helper.ShowMessage(response.data);
                this.GetInfo(this.pageNo);
            }).catch(error => {
                this.$blockUI.Stop();
                this.$helper.ShowMessage(error.response.data, 'error');
            });
        },

        GenerateCode() {
            let result = '';
            let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
            let charactersLength = characters.length;
            for (let i = 0; i < 8; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        }
    }
}
